TS.ns('WL');

WL.documentBase = new Class({
    Extends: WL.EditBase,
     
    initialize: function (config) {
        var me = this;

        me.parent(config);

        var actionList = me.getDomainProperty('grdLeasingActionCollection_Property');

        if (actionList != null) {
            actionList.getFieldByName('gcDetails_Field').renderer = "hyperlinkGrid";

            TS.UI.Renderers.grid.hyperlinkGrid = {
                getCellClass: function (field, dataItem) {
                    return 'grid-hyperlink';
                }
            };
        }
    },    

    createProperties: function (config) {
        var me = this;

        me.parent(config);

        var propertyList = me.getDomainProperty('PropertyList');

        if (propertyList) {
            propertyList.on('addNew', me.onPropertyAdded);
            propertyList.on('cellValueChanged', me.onPropertyChanged, me);
        }

        var stateTransitionList = me.getDomainProperty('grdStateTransitionCollection_Property');
        if (stateTransitionList != null) {

            //me.ImageNumberVisible = ko.computed(function () {
            //    if (me.ShowTransitionImage())
            //        return true;
            //    return false; 
            //});
             
            stateTransitionList.on('cellBeginEdit', me.onStateTransitionListBeginEdit);

            stateTransitionList.getFieldByName('gcReasons_Field').renderer = "smallWrap";
            stateTransitionList.getFieldByName('gcFreeTxt_Field').renderer = "smallWrap";
            stateTransitionList.getFieldByName('gcImageNumber_Field').renderer = "hyperlinkGrid";
            //stateTransitionList.getFieldByName('gcImageNumber_Field').Visible(me.ImageNumberVisible()); 

            TS.UI.Renderers.grid.smallWrap = {
                getCellClass: function (field, dataItem) {
                    return 'wrap-text';
                }
            };

            TS.UI.Renderers.grid.hyperlinkGrid = {
                getCellClass: function (field, dataItem) {
                    return 'grid-hyperlink';
                }
            };
        }

        var verificationList = me.getDomainProperty('dgVerification_Property');
        if (verificationList) {
            verificationList.on('cellBeginEdit', me.onVerificationCellEdit);
        }
         
        verificationList = me.getDomainProperty('dgVerification_Property');
        if (verificationList != null) {

            verificationList.getFieldByName('gcVerificationName_Field').renderer = "hyperlinkGrid";

            TS.UI.Renderers.grid.hyperlinkGrid = {
                getCellClass: function (field, dataItem) {
                    return 'grid-hyperlink';
                }
            };
        }

        var actionList = me.getDomainProperty('grdLeasingActionCollection_Property');
        if (actionList != null) {
            actionList.on('cellBeginEdit', me.onActionBeginEdit);

            cat = actionList.Commands;

            newCmd = new TS.domain.Command();
            newCmd['Code'] = 'AddAction';
            newCmd['Text'] = me.AddActionCommandText;
            newCmd['handler'] = '_addAction';
            newCmd['IconCode'] = 'plus';

            if (!me.ReadOnly())
                cat.push(newCmd);
        }

        var commentList = me.getDomainProperty('dgDocumentCommentCollection_Property');
        if (commentList != null) {
            me.cmdVisibleDelete = ko.computed(function () {
                if (commentList.SelectedItem() == null)
                    return false;
                return WL.Config.DocumentCommentEditability == 'Yes' || (WL.Config.DocumentCommentEditability == 'User-conditioned' && commentList.SelectedItem().UserId() == me.CurrentUserId());
            });
            commentList.getCommand('Delete').InternalVisible = me.cmdVisibleDelete;
            commentList.on('cellBeginEdit', me.onCommentListBeginEdit);
        }
  
    },

    onCommentListBeginEdit: function (e) {
        var me = this,
            owner = me._Domain,
            commentList = owner.getDomainProperty('dgDocumentCommentCollection_Property');

        if (e.fieldName == 'FreeTxt' && (WL.Config.DocumentCommentEditability == 'Yes' || (WL.Config.DocumentCommentEditability == 'User-conditioned' && commentList.SelectedItem().UserId() == me._Domain.CurrentUserId())))
            return;

        e.preventDefault();
    },

    onStateTransitionListBeginEdit: function (e) {
        var me = this,
            owner = me._Domain,
            stateTransitionList = owner.getDomainProperty('grdStateTransitionCollection_Property');
        
        if (e.fieldName == 'ImageNumber') {
            e.preventDefault();

            if (stateTransitionList.SelectedItem().ImageId() == null)
                return;

            owner.performServerCommand({
                cmd: 'OpenDocumentImage',
                submitModel: true,
                extraData: { ImageId: stateTransitionList.SelectedItem().ImageId(), ImageSiteId: stateTransitionList.SelectedItem().ImageSiteId() },
                blockUI: false
            });
        }
        else if (e.fieldName == 'Selected') {
            if (stateTransitionList.SelectedItem().ImageId() == null)
                e.preventDefault();
        }
        else if (owner.ReadOnly) {
            e.preventDefault();
        }
    },

    onPropertyChanged: function (e) {
        var me = this,
          rec = e.item;

        if (e.fieldName != 'PropertyId')
            return;

        me.performServerCommand({
            cmd: 'RefreshProperty',
            submitModel: true,
            extraData: {
                NewValue: e.newValue,
                rowIdx: e.rowIdx
            },
            blockUI: true
        })
    },

    onPropertyAdded: function (e) {
        var me = this,
          rec = e.item;

        rec.PropertyTypeCode = new ko.observable('Text');
        rec.EditorName = new ko.observable('Text');
        rec.EditorType = new ko.observable('Text');
        rec.Default = new ko.observable('false');
    },

    onPropertyEdit: function (e) {
        var me = this,
            rec = e.item;

        if (e.fieldName != 'PropertyId')
            return; 

        if (e.record.Default() == true)
            e.preventDefault();
    },

    _addAction: function () {
        var me = this;

        me.performServerCommand({
            cmd: 'AddAction',
            submitModel: true,
            blockUI: false
        });
    },

    onActionBeginEdit: function (e) {
        var me = this,
            owner = me._getOwner();

        if (e.fieldName == 'Details') {
            e.preventDefault();
            owner._editAction();
        }
        else if (owner.ReadOnly) {
            e.preventDefault();
        }
    },

    _editAction: function () {
        var me = this;

        var actionList = me.getDomainProperty('grdLeasingActionCollection_Property');

        me.performServerCommand({
            cmd: 'EditAction',
            submitModel: true,
            extraData: { UID: actionList.SelectedItem().UID() },
            blockUI: false
        });
    }

});